module.exports = __webpack_public_path__ + "img/oasis-7.63628db7.png";